"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCookieStoreInfo = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _models = require("../models");
const useCookieStoreInfo = () => {
  const [cookieInfo, setCookieInfo] = (0, _react.useState)({
    type: _models.ReferralType.None,
    productListType: 'Personal'
  });
  (0, _react.useEffect)(() => {
    const pbsOwnerCookie = _jsCookie.default.get(_presentationUtils.PbsCookieNames.PBS_OWNER);
    if (pbsOwnerCookie) {
      setCookieInfo({
        owner: pbsOwnerCookie,
        productListType: 'Personal',
        type: _models.ReferralType.PBS
      });
    }
  }, []);
  return cookieInfo;
};
exports.useCookieStoreInfo = useCookieStoreInfo;
